import {BaseTerms} from "../../infrastructure/models/base-terms";

export class WebsiteModuleTerms extends BaseTerms {
  BACK_TO_TOP = 'Back to top';
  CHANGE_COUNTRY_USA_POPUP = 'Wanna see the US version of our site?';
  WEB_POPUP_BUTTON_YES = 'Yes';
  WEB_POPUP_BUTTON_NO = 'No';


  WEB_CONFIRMATION_TOASTER_GAME_ADDED = '';
  WEB_CONFIRMATION_TOASTER_GAME_REMOVED = '';
  WEB_CONFIRMATION_TOASTER_COMPETITOR_ADDED = '';
  WEB_CONFIRMATION_TOASTER_COMPETITOR_REMOVED = '';
  WEB_CONFIRMATION_TOASTER_COMPETITION_ADDED = '';
  WEB_CONFIRMATION_TOASTER_COMPETITION_REMOVED = '';

  TABLE_AND_STANDINGS = 'Table & Standings';
  PAGE_NOT_FOUND_TITLE = '404 Page Not Found';
}
